export const SET_LOADING_HEADER_NAME = 'Set-Loading';
export const SET_LOADING_HEADER = { [SET_LOADING_HEADER_NAME]: true };
